module.exports = __webpack_public_path__ + "img/touch-panel.a3d62d6a.png";